import React, { useState } from 'react';
import { Trans } from '@ui/i18n/trans';
import { Dialog } from '@ui/overlays/dialog/dialog';
import { DialogHeader } from '@ui/overlays/dialog/dialog-header';
import { DialogBody } from '@ui/overlays/dialog/dialog-body';
import { TextField } from '@ui/forms/input-field/text-field/text-field';
import { SearchIcon } from '@ui/icons/material/Search';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { addCompanyMemberApi, searchFreeMembersApi } from './api';
import { useAuth } from '@common/auth/use-auth';
import { toast } from '@ui/toast/toast';
import { message } from '@ui/i18n/message';
import { useTrans } from '@ui/i18n/use-trans';

export function AddMemberDialog({disabled} : {disabled?: boolean}) {
    const [query, setQuery] = useState('');
    const { data } = useQuery({
        queryKey: ['searchFreeMembers', query],
        queryFn: () => { return searchFreeMembersApi({ query }) },
        select: (data) => data.data.users
    })
    const {trans} = useTrans();


    return (
        <Dialog>
            <DialogHeader>
                <Trans message="Add Member" />
            </DialogHeader>
            <DialogBody>
                <TextField
                    size="sm"
                    className="w-full"
                    inputWrapperClassName=""
                    placeholder={trans(message('Search to add new members.'))}
                    startAdornment={<SearchIcon size="sm" />}
                    value={query}
                    onChange={(e) => { setQuery(e.target.value) }}
                />
                <div className='overflow-y-auto max-h-[450px] mt-16'>
                    {query.length > 0 && data?.map((user: User) => (
                        <SearchResult id={user.id} image={user.image || ''} name={`${user.name}`} email={user.email} key={user.id} disabled={disabled} />
                    ))}
                </div>
            </DialogBody>
            {/* <DialogFooter>
        <Button variant="outline" onClick={() => close()}>
          <Trans message="Cancel" />
        </Button>
        <Button
          variant="flat"
          color="primary"
          type="submit"
          form={formId}
          disabled={createUser.isPending}
        >
          <Trans message="Create" />
        </Button>
      </DialogFooter> */}
        </Dialog>
    );
}

interface SearchResultInterface {
    image: string;
    name: string;
    email: string;
    id: number;
    disabled?: boolean;
}

function SearchResult({ image, name, email, id, disabled }: SearchResultInterface) {
    const { user } = useAuth();
    const queryClient = useQueryClient()
    const [isLoading, setIsLoading] = useState(false);
    const {mutate} = useMutation({
        mutationKey: ['addCompanyMember'],
        mutationFn: ()=>{return addCompanyMemberApi({userId: id, companyId: user?.id || 0})},
        onSuccess: ()=>{
            queryClient.invalidateQueries({ queryKey: ['searchFreeMembers'] });
            queryClient.invalidateQueries({ queryKey: ['companyMembers'] });
            toast(message('Member added successfully!'));
            setIsLoading(false);
        },
        onError: (error) => {
            toast.danger(message('Something wrong!'));
            setIsLoading(false);
            console.error(error);
        }
    })

    if (id === user?.id)
        return undefined;

    return (
        <div className='flex p-10 items-center justify-between hover:bg-primary hover:bg-opacity-10 rounded-md'>
            <div className="flex items-center">
                <img src={image} alt={`${name} image`} className='w-[60px] h-[60px] object-cover rounded-full' />
                <div className='ml-8'>
                    <h3>{name}</h3>
                    <h4 className='text-gray-600'>{email}</h4>
                </div>
            </div>
            <button disabled={disabled} onClick={()=>{setIsLoading(true); mutate();}} className='text-white flex items-center justify-center bg-primary h-30 w-30 rounded-full disabled:bg-gray-400'><i className={`fa-solid ${isLoading ? 'fa-circle-notch fa-spin' : 'fa-plus'}`}></i></button>
        </div>
    )
}